import React, { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import DisplayQtyMinQtyMult from 'src/component/custom/DisplayQtyMinQtyMult';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useProductStore } from 'src/hooks/product';
import useDebounce from 'src/hooks/useDebounce';

const QuantityPicker = (props) => {
    // Destructuring Props
    const { single_product, force_default_quantity, readOnly_quantity, CHECK_CART_RELATED_INVENTORY_VALIDATION, disable_increase_decrease,
        single_product_inventory, invalid_quantity_message_text = 'Invalid Quantity', single_product_pricing_list, isFrom } = props;

    // Special offer
    // const pkg = single_product.PackagingTypeCode;
    // const stock = single_product_inventory.inventoryQty;
    // const isSpecialOffer = (single_product.isAvnetDistributor && stock > 0) && (stock < single_product.QtyMin)
    // const minQty = isSpecialOffer ? (single_product_inventory.inventoryQty < single_product.QtyMult) ? 1 : single_product.QtyMult : single_product.QtyMin;

    // const multQty = (isSpecialOffer && (System.isSpecialOfferPkg(pkg) || single_product_inventory.inventoryQty < single_product.QtyMult)) ? 1 : single_product.QtyMult

    let specialOffer = System.checkSpecialOffer(single_product, single_product_inventory)
    let isSpecialOffer = specialOffer.isSpecialOffer
    const minQty = isSpecialOffer ? specialOffer.minQty : single_product.QtyMin;
    const multQty = isSpecialOffer ? specialOffer.multQty : single_product.QtyMult

    const [__check] = useAxiosIndicatorCheck();
    const uniqueId = props.qp_unique_id ? props.qp_unique_id : single_product.ItemNumber
    const { QuantityAction: { Minus, Plus }, systemModules: { BOM, CART } } = Constants;
    const [isEditEnable, setIsEditEnable] = useState(false);
    const [{ CART_DATA }, { backorder_not_available }, { SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT }] = useCartStore();
    const [QtyMult, setQtyMult] = useReduxState(multQty, 'single_product__QtyMult' + uniqueId);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [QtyMin, setQtyMin] = useReduxState(minQty, 'single_product__QtyMin' + uniqueId);
    // const initialMinVal = isFrom !== BOM && isFrom !== CART && isEditEnable ? "" : QtyMin;
    const [quantityVal, setQuantityVal] = useReduxState(QtyMin, 'single_product__QuantityVal' + uniqueId);
    const [qtyDebounce, setQtyDebounce] = useDebounce(false, 700);
    const [quantityError, setQuantityError] = useState('');

    const [{ }, { get_inventory_by_distributor }, { },] = useProductInventoryPriceStore();
    const isFromCart = System.isCallFromCart();

    const [priceSingleLoader, setPriceSingleLoader] = useReduxState({}, 'priceSingleLoader')
    const [addToCartSingleClick] = useReduxState({}, 'addToCartSingleClick')
    const [addToCartClick] = useReduxState({}, 'addToCartClick')
    const [{ }, { get_product_assets }, { }, { }] = useProductStore();


    useEffect(() => {
        let editEnable = System.checkIsEnableQuantity(single_product_pricing_list)
        setIsEditEnable(System.checkIsEnableQuantity(single_product_pricing_list))
        setQuantityVal(isFrom !== BOM && isFrom !== CART && editEnable ? "" : QtyMin)
    }, []);

    useEffect(() => {
        if (force_default_quantity) {
            setQuantityVal(force_default_quantity && force_default_quantity > 0 ? force_default_quantity : disable_increase_decrease ? '' : QtyMin)
        }
    }, [force_default_quantity]);

    useEffect(() => {
        if (single_product?.partNumber) {
            setQtyMin(minQty)
            setQtyMult(multQty)
        }
    }, [single_product?.partNumber]);

    useEffect(() => {
        async function fetchHere() {
            let isMinMultUpdate = false
            if (isSpecialOffer) {
                let min = (quantityVal > single_product_inventory.inventoryQty) ? single_product.QtyMin : minQty
                let mult = (quantityVal > single_product_inventory.inventoryQty) ? single_product.QtyMult : multQty
                
                if (min !== QtyMin) {
                    isMinMultUpdate = true
                    setQtyMin(min)
                }
                if (mult !== QtyMult) {
                    isMinMultUpdate = true
                    setQtyMult(mult)
                }
            }
            if (single_product) {
                const updatedProduct = { ...single_product, quantityUpdateToCart: quantityVal };
                await manageDispatch(updatedProduct);
                if (!isMinMultUpdate) {
                    validateQuantity(quantityVal)
                }
            }
            if (isEditEnable && isFrom !== CART && !firstServerCall) {
                setQtyDebounce(quantityVal)
            }
        }
        fetchHere();
    }, [quantityVal]);

    useEffect(() => {
        async function fetchHere() {
            if (qtyDebounce !== false ) {
                if(!quantityError) {
                    setPriceSingleLoader({ [single_product.ItemNumber]: { status: true } })
                    let product = {
                        ...single_product, quantity: quantityVal, uniqueId: uniqueId
                    }
                    await get_product_assets({ product }, { isInventoryCall: false })
                }
                
                if (props.getPlanInputQuantityCallback) {
                    props.getPlanInputQuantityCallback(quantityVal) // bomExactMatch update quantity callback when edit scenerio
                }
                setPriceSingleLoader({ [single_product.ItemNumber]: { status: false } })
            }
        }
        fetchHere();
    }, [qtyDebounce]);

    useEffect(() => {
        validateQuantity(quantityVal)
    }, [CART_DATA[single_product.ItemNumber]?.quantity, CART_DATA[single_product.ItemNumber]?.backOrderedQuantity, single_product_inventory, QtyMin, addToCartSingleClick]);

    // -----All useEffects over----- //

    const setQuantityWithAction = async (action) => {
        let qty = quantityVal;
        if (quantityVal === "" && firstServerCall) {
            qty = 0;
        }

        // if (isEditEnable && firstServerCall && isFrom !== BOM && isFrom !== CART) {
        //     const payload = { ...single_product, is_updated_qty: true };
        //     manageDispatch(payload)
        //     setFirstServerCall(false);
        //     validateQuantity(quantityVal, false)
        //     qty = 0;
        //     // return
        // }
        // let qty = quantityVal
        if (action === Minus) {
            if (isSpecialOffer) {
                qty = qty <= single_product.QtyMin && qty > single_product_inventory.inventoryQty ? single_product_inventory.inventoryQty : qty <= QtyMin ? QtyMin : (qty - QtyMult)
            } else {
                qty = qty <= QtyMin ? QtyMin : (qty - QtyMult)
            }
        } else {
            let productQty = get_inventory_by_distributor(single_product, single_product_inventory)
            if (backorder_not_available(single_product) && qty > productQty && isFromCart) {
                System.popup('BackorderNotAvailable', { singleProduct: single_product })
            } else {
                if (isSpecialOffer) {
                    qty = qty >= single_product_inventory.inventoryQty && qty < single_product.QtyMin ? single_product.QtyMin : qty < QtyMin ? QtyMin : (qty + QtyMult)
                } else {
                    qty = qty < QtyMin ? QtyMin : (qty + QtyMult)
                }
            }
        }
        await manageTempQuantity(qty, 200)
    };

    const validateQuantity = (qty, isValidateClick = true) => {
        let res = ''
        if (qty >= 0 && qty !== "") {
            if (QtyMin < QtyMult && qty % QtyMin !== 0) {
                res = invalid_quantity_message_text;
            } else if (QtyMin && qty < QtyMin) {
                res = invalid_quantity_message_text;
            } else if (QtyMult && qty % QtyMult !== 0) {
                res = invalid_quantity_message_text;
            } else if (CHECK_CART_RELATED_INVENTORY_VALIDATION === true && single_product.ERPPartNumber && !single_product.SoftwareDownloadFlag) {
                let productQty = get_inventory_by_distributor(single_product, single_product_inventory)
                if ((CART_DATA[single_product.ItemNumber]?.quantity > productQty) === true && CART_DATA[single_product.ItemNumber]?.backOrderedQuantity === 0) {
                    res = "Insufficient inventory"
                } else if (CART_DATA[single_product.ItemNumber]?.unitPrice === 0) {
                    res = "Entered quantity requires a quote. Lower quantity or remove from cart."
                }
            }
        } else if (qty === "" && addToCartSingleClick[single_product.ItemNumber]?.clicked && isEditEnable && firstServerCall && isValidateClick) {
            res = invalid_quantity_message_text;
        }

        const payload = {
            ...single_product,
            quantityUpdateToCart: qty,
            invalid_quantity: res ? true : false,
            is_updated_qty: System.checkIsEnableQuantity(single_product_pricing_list) && firstServerCall && isFrom !== BOM && isFrom !== CART ? false : true
        };
        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT(payload)
        setQuantityError(res)
        return res ? true : false
    };
    const manageTempQuantity = async (qty, timeOut = 700) => {
        setFirstServerCall(false)

        qty = parseInt(qty);

        if (isNaN(qty)) {
            qty = disable_increase_decrease ? '' : 0;
        }
        // if (!firstServerCall)
        setQuantityVal(qty)

        const delayDebounceFn = setTimeout(async () => {
            if (qty === false) return;

            if (props.disable_edit_force_default_quantity) { // cart quantitypicker, bomExactMatch, cartManuallyAddPart -- true

                if (props.getPlanInputQuantityCallback && !isEditEnable) {
                    props.getPlanInputQuantityCallback(qty) // bomExactMatch update quantity callback without edit scenerio
                }
                
                if (props.getPlanInputQuantityValidatedCallback && quantityVal !== qty) {
                    props.getPlanInputQuantityValidatedCallback(qty)
                    return;
                }
            }

        }, timeOut);


        return () => clearTimeout(delayDebounceFn)
    }

    const manageDispatch = async (single_product_here) => {
        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT(single_product_here)
    };

    const getDisableStatus = () => {
        if (__check(['CART_OPERATION_API_CALL']).status || readOnly_quantity) {
            return true;
        } else if (addToCartClick[single_product.ItemNumber]?.clicked && firstServerCall) {
            return true
        }
            return false;
    };

    return (
        <>
            {single_product?.ItemNumber &&
                <>
                    <div className="quantity w-auto clearfix ">
                        <div className={quantityError ? "quantity-picker error" : "quantity-picker"}>
                            <div className="bs5 input-group flex-nowrap border-0">
                                {!disable_increase_decrease &&
                                    <span className="bs5 input-group-prepend flex-nowrap">
                                        <button
                                            disabled={getDisableStatus()}
                                            type="button"
                                            aria-label="Decrease Quantity"
                                            onClick={() => { setQuantityWithAction(Minus) }}
                                            className="bs5 btn btn-outline-secondary btn-number br-0"
                                        >
                                            <span className="fa fa-minus" />
                                        </button>
                                    </span>
                                }

                                <input
                                    type="text"
                                    disabled={getDisableStatus()}
                                    className="form-control form-control-sm"
                                    aria-labelledby="Quantity"
                                    // value={isEditEnable && firstServerCall && isFrom !== BOM && isFrom !== CART ? '' : quantityVal}
                                    value={quantityVal}
                                    placeholder={'Enter Quantity'}
                                    onChange={async (e) => {
                                        await manageTempQuantity(e.target.value);
                                    }}

                                />
                                {!disable_increase_decrease &&
                                    <span className="bs5 input-group-append flex-nowrap">
                                        <button
                                            disabled={getDisableStatus()}
                                            type="button"
                                            aria-label="Increase Quantity"
                                            onClick={() => { setQuantityWithAction(Plus) }}
                                            className="bs5 btn btn-outline-secondary btn-number bl-0"
                                        >
                                            <span className="fa fa-plus" />
                                        </button>
                                    </span>
                                }
                            </div>

                            {/* manage validations */}
                            {quantityError && <span className="mandatory">{quantityError} </span>}

                        </div>
                    </div>
                    {props.showDisplayQtyMinQtyMult &&
                        <div className="text-start small-text light light-text collapse_minmax">
                            <DisplayQtyMinQtyMult single_product={single_product} />
                        </div>
                    }
                </>
            }
        </>
    );
}

export default QuantityPicker;